import { userConstants } from '../constants';

const initialState = {
	// Login states
	isAuthenticated : false,
	isLoading: false,
	error: null,

	// User
	data: null
};

export default (state = initialState, payload) => {
	const { type, data, error } = payload;
	const { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_REQUEST } = userConstants;
	switch (type) {
		case LOGIN_REQUEST:
			return {
				...state,
				isLoading: true,
				isAuthenticated: false,
				error: null
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				isLoading: false,
				isAuthenticated: true,
				error: null,
				data
			};
		case LOGIN_FAILURE:
			return {
				...state,
				isLoading: false,
				isAuthenticated: false,
				error: error,
				data: null
			};
		case LOGOUT_REQUEST:
			return {
				...initialState
			}
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/user.reducers.js